<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CompanyService from "@/services/company";

export default {
  page: {
    title: "Opções de Entrega",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Opções de Entrega",
      settings: {},
      options: [],
      loading: false,
    };
  },
  methods: {
    save() {
      let loader = this.$loading.show();

      const data = this.options.map(item => {
        return {
          _id: item._id,
          description: item.description,
          active: item.active,
        }
      })

      CompanyService.updateShippingOption(data).then(() => {
        loader.hide();
        this.$toast.open('Configuração de entrega atualizada');
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao gravar');
        loader.hide();
      })
    },
   load(showLoading = true) {
      let loader;
      if (showLoading) {
        loader = this.$loading.show();
      }

      CompanyService.getShippingOptions().then(res => {
        this.options = res.data;
        if (loader) {
          loader.hide();
        }
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao carregar os dados');

        if (loader) {
          loader.hide();
        }
      })
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <div class="card" v-for="(option, index) in options" :key="option._id">
      <div class="card-body">
        <h4 class="card-title">{{option.method === 'delivery' ? 'ENTREGA / DELIVERY' : 'RETIRADA'}}</h4>
        <!-- <p class="card-title-desc">Configurações da entrega</p> -->

        <form class="mt-4">
          <div class="row">
            <div class="col-sm-12">
              <div class="custom-control custom-checkbox mb-2">
                <input type="checkbox" class="custom-control-input" :id="'active' + index" :name="'active' + index" v-model="option.active" />
                <label class="custom-control-label" :for="'active' + index">Ativo</label>
              </div>
            </div>
          </div>
          
          <div class="row mt-2">
            <div class="col-sm-6">
              <div class="form-group">
                <label :for="'description' + index">Nome para exibição</label>
                <input :id="'description' + index" :name="'description' + index" type="text" class="form-control" v-model="option.description" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row mt-4 align-items-center">
      <div class="col-sm-12">
        <div class="text-sm-right">
          <b-spinner class="m-2" variant="primary" role="status" v-if="loading"></b-spinner>
          <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="save" v-if="!loading">
            <i class="mdi mdi-plus mr-1"></i> Salvar Configurações
          </button>
        </div>
      </div>
    </div>
  </Layout>
</template>
